import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Activity, ArrowRight } from "lucide-react";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { getRouteForNavigation } from "@/utils/routeAccess";

export default function TestRequests({
  conciergeRequests,
  isLoading,
  title = "Test Requests",
  emptyStateButtonText = "Request Your First Test",
}) {
  const recentConciergeRequests = conciergeRequests?.slice(0, 3) || [];

  return (
    <Card className="bg-white/60 backdrop-blur-sm border-slate-200/60 shadow-xl">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-slate-900">
            <Activity className="w-5 h-5 text-purple-600" />
            {title}
          </div>
          <Link to={getRouteForNavigation("Concierge Testing")}>
            <Button variant="ghost" size="sm">
              View All
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-3">
            {Array(3)
              .fill(0)
              .map((_, i) => (
                <div key={i} className="animate-pulse">
                  <div className="h-16 bg-slate-200 rounded-lg"></div>
                </div>
              ))}
          </div>
        ) : recentConciergeRequests.length > 0 ? (
          <div className="space-y-3">
            {recentConciergeRequests.map((request) => (
              <div
                key={request.id}
                className="p-4 bg-slate-50/60 rounded-lg border border-slate-200/60 hover:bg-slate-100/60 transition-colors"
              >
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-slate-900">
                    {request.requestedTests?.join(", ") || "Test Request"}
                  </h4>
                  <span
                    className={`text-xs px-2 py-1 rounded-full ${
                      request.status === "completed"
                        ? "bg-green-100 text-green-700"
                        : request.status === "in_progress"
                          ? "bg-blue-100 text-blue-700"
                          : "bg-yellow-100 text-yellow-700"
                    }`}
                  >
                    {request.status}
                  </span>
                </div>
                {request.preferredDate && (
                  <p className="text-sm text-slate-600">
                    Preferred:{" "}
                    {format(new Date(request.preferredDate), "MMM d, yyyy")}
                  </p>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <Activity className="w-12 h-12 mx-auto text-slate-300 mb-3" />
            <p className="text-slate-500">No test requests yet</p>
            <Link to={getRouteForNavigation("Concierge Testing")}>
              <Button variant="outline" size="sm" className="mt-2">
                {emptyStateButtonText}
              </Button>
            </Link>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
